import React from 'react';

export const DescriptionColumn = ({ children, fontSize, isBold = false, padding = undefined }) => {
  return <td style={{ fontSize: fontSize, fontWeight: isBold ? 'bold' : 'unset', flexGrow: 1, padding: padding || '0px' }}>{children}</td>;
};
